<style scoped lang="less">
.layout{width: 301px;height: auto;background: rgba(34, 85, 172, 0.88);-webkit-filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2)); filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2));overflow: hidden;transform: translate(-50%, -50%);border: 1px solid #6491e0;border-radius: 6px;}
.title{height: 35px;background-color: #2080ff;margin: 0;line-height: 35px;text-align: right;padding: 0 20px;color: #fff; font-size: 16px;display: flex;justify-content: space-between;}
.popup-tool {height: 45px;line-height: 45px;color: #fff; font-family: Microsoft YaH;text-align: left;padding: 0px 10px;border:solid 1px rgb(33, 185, 191)}
.popup-content {color: #d6d4d4; font-family: Microsoft YaH;text-align: left;padding: 5px;border-top: none;}
.ol-popup-closer:after {content: "✖";color: #fff;}
/deep/.el-input.is-disabled .el-input__inner {background: rgba(10, 17, 43, 0.4);border: solid 1px #3c818d;}
/deep/.el-select .el-input.is-disabled .el-input__inner:hover {border: solid 1px #3c818d;}
/deep/.el-form-item__label {padding: 0;color: #fff;text-align: center;}
/deep/.el-form-item {margin: 15px;}
/deep/.el-input__inner {color: #000;}
.el-button {border-radius: 4px;border: solid 1px #2080ff;}
.el-button--primary {color: #FFF;background-color: #2080ff;}
.el-button--default {color: #FFF;background: #2080ff;}
/deep/.el-input__inner{ background-color: transparent !important; border: solid 1px #7ae9ff;border-radius: 5px;color: #fff;}
.el-select{width: 100%;}
/deep/ .el-input__inner::placeholder {
  color: #ffffff;
}
.setstyle {
    min-height: 200px;
    padding: 0 !important;
    margin: 0;
    overflow: auto;
    background-color:#fff !important;
    cursor: default !important;
  }
</style>

<template>
<div class="layout" v-drag v-if="flag">
    <div class="popup-content">
      <el-form ref="rulesform" :model="rulesform" :rules="rules">
            <el-form-item prop="type">
              <el-select ref="select" v-model="rulesform.type" @change="selectChange" clearable placeholder="类别">
                <el-option :value="selectTree" class="setstyle">
                    <el-tree :data="data" :props="defaultProps" ref="tree" :highlight-current="true" @node-click="handleNodeClick"></el-tree>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="rulesform.way" clearable placeholder="方式：空间查询/属性查询">
                <el-option
                  v-for="item in wayOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="attribute" v-if="this.rulesform.way === '1'">
              <el-select v-model="rulesform.attribute" clearable placeholder="属性字段">
                <el-option
                  v-for="item in attOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="attvalue" v-if="this.rulesform.way === '1'">
              <el-input v-model="rulesform.attvalue" placeholder="属性值"></el-input>
            </el-form-item>
            <el-form-item v-if="this.rulesform.way === '2'">
              <el-tooltip class="item" effect="dark" :content="group.label" placement="bottom" plain v-for="(group, index) in markdata" :key="index">
                <el-button type="primary" class="cross" @click="onMeasures(group, index)">
                  <span>
                    <i :class="group.icon"></i>
                  </span>
                </el-button>
              </el-tooltip>
            </el-form-item>
            <el-form-item>
              <el-button v-if="this.rulesform.way === '1'" type="primary" @click="onSubmit('rulesform')">确定</el-button>
              <el-button v-if="this.rulesform.way === '1'" @click="cancel">重置</el-button>
            </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
export default {
  data()
  {
    //验证规则
    let InputAtt = (rule, value, callback) =>
    {
      if (!value)
        return callback(new Error('属性值不能为空'))
    }
    //验证规则
    let InputAttribute = (rule, value, callback) =>
    {
      if (!value)
        return callback(new Error('属性字段不能为空'))
    }
    //验证规则
    let InputType = (rule, value, callback) =>
    {
      if (!value)
        return callback(new Error('类别不能为空'))
    }
    return {
      flag: false,
      rulesform: {
        type: '',
        layer: '',
        way: '1',
        attribute: '',
        attvalue: ''
      },
      draw: null,
      drawLayer: null,
      typeOptions: [], //类别
      layerOptions: [], //类别
      wayOptions: [
        {value: '1', label: '属性查询'},
        {value: '2', label: '空间查询'}
      ], // 方式
      attOptions: [], //属性字段
      data: [],
      defaultProps: {
        children: 'children',
        label: 'namec'
      },
      selectTree: [],
      labelData: '',
      layerData: '',
      allData: [],
      rules: {
        type: [{ validator: InputType, trigger: 'blur' }],
        attvalue: [{ validator: InputAtt, trigger: 'blur' }],
        attribute: [{ validator: InputAttribute, trigger: 'blur' }]
      },
      markdata:
      [
        {icon: 'iconfont icon-yuanxing', label: '圆', title: 'Circle', function: 'Mark'},
        {icon: 'iconfont icon-juxing', label: '矩形', title: 'Rectangle', function: 'easureMent'},
        {icon: 'iconfont icon-duobianxing', label: '多边形', title: 'Polygon', function: 'easureMent'}
      ]
    }
  },
  created()
  {
    this.getDefultData()
  },
  mounted()
  {
    this.$nextTick(() =>
    {
      this.getWMS()
    })
  },
  methods: {
    //取wms图层服务
    getWMS()
    {
      let paras = {cmd: 'query', _major: 99, _minor: 31, _exp: 'visible=1', vals: this.Title}
      window.post.getPost(paras).then((ret) =>
      {
        this.allData = ret
        let layerNds = ret.map(item => cx.base.extend({}, item, {children: []}))
        this.data = this.getNodes(layerNds)
        console.log(this.data)
      })
    },
    /**
     * 构造树节点
     * @method
     * @param     {Array<Object>}   nodes   节点数组
     * @returns   {Array<Object>}           构造好的树节点集合
     */
    getNodes(nodes)
    {
      let flterNodes = nodes.filter(node => node.glid === 0)
      for (let i = 0, il = flterNodes.length; i < il; ++i)
        this.makeChildrenData(flterNodes[i].children, flterNodes[i].id, nodes)
      return nodes.filter(node => node.glid === 0)
    },
    /**
     * 构造children数据
     * @method
     * @param   {Array<Object>}   children    父节点的children对象
     * @param   {Number}          glid        父节点的id
     * @param   {Array<Object>}   data        所有节点的源数据集合
     */
    makeChildrenData(children, glid, data)
    {
      let flterData = data.filter(item => item.glid === glid)
      for (let i = 0, il = flterData.length; i < il; ++i)
      {
        //判断该节点是否有图层
        if (!flterData[i].filter)
          flterData[i].icon = 'iconfont icon-bukeshi'
        children.push(flterData[i])
        if (data.some(node => node.glid === flterData[i].id))
          this.makeChildrenData(flterData[i].children, flterData[i].id, data)
      }
    },
    // 获取选中节点的父节点
    getParentType(val)
    {
      if (val.glid === 0)
        this.labelData = this.labelData ? this.labelData : val.namec + this.labelData
      else
      {
        if (val.layer)
          this.layerData = val.layer
        let parent = this.allData.filter(item => item.id === val.glid)
        this.labelData = parent[0].namec + `/${this.labelData}`
        this.$refs.select.blur()

        if (parent[0].glid)
          this.getParentType(parent[0])
      }
    },
    // 点击类型图层下拉框选择数据
    handleNodeClick(node, self, child)
    {
      this.layerData = ''
      this.labelData = ''
      if (node.layer !== '')
      {
        if (node.glid !== 0)
        {
          this.getParentType(node)
          this.labelData = this.labelData + node.namec
        }
        else
          this.getParentType(node)
        this.rulesform.type = this.labelData
        if (this.layerData)
          this.getLayerAttData(this.layerData)
      }
    },
    // 获取图层属性字段
    getLayerAttData(val)
    {
      let url = `https://www.camining.cn/zgis/mapserver/zgis/wms?service=wfs&version=2.0.0&request=GetFeature&typeNames=${val}&outputFormat=application/json&srsname=EPSG:4326&count=1`
      // let url = `/layer?service=wfs&version=2.0.0&request=GetFeature&typeNames=${val}&outputFormat=application/json&srsname=EPSG:4326&count=1`
      Axios.get(url).then(res =>
      {
        if (res.status === 200 && res.data.features.length > 0)
        {
          this.attOptions = []
          Object.keys(res.data.features[0].properties).forEach(item =>
          {
            if (item !== 'OBJECTID')
              this.attOptions.push({label: item, value: item})
          })
        }
      })
    },
    // 获取类型数据
    getDefultData()
    {
      let paras = {cmd: 'query', _major: 99, _minor: 31, _exp: 'visible=1 and glid = 0', vals: this.Title}
      window.post.getPost(paras).then((ret) =>
      {
        if (ret.length > 0)
        {
          this.typeOptions = []
          ret.forEach(item =>
          {
            this.typeOptions.push({value: item.id, label: item.namec})
          })
        }
      })
    },
    // 获取图层数据
    selectChange(val)
    {
      if (val)
        this.rulesform.layer = ''
      let paras = {cmd: 'query', _major: 99, _minor: 31, _exp: `visible=1 and glid = ${val}`, vals: this.Title}
      window.post.getPost(paras).then((ret) =>
      {
        if (ret.length > 0)
        {
          this.layerOptions = []
          ret.forEach(item =>
          {
            this.layerOptions.push({value: item.id, label: item.namec})
          })
        }
      })
    },
    showLP()
    {
      this.flag = !this.flag
    },
    closePul(show)
    {
      this.flag = show
    },
    // 属性查看确定
    onSubmit(form)
    {
      if (this.rulesform.attribute !== '' && this.rulesform.attvalue !== '' && this.rulesform.type !== '')
      {
        // 组织like查询条件
        let exp = `"${this.rulesform.attribute}" LIKE '%${this.rulesform.attvalue}%'`
        // 对条件进行url转码
        let att = encodeURI(exp)
        let url = `https://www.camining.cn/zgis/mapserver/zgis/wms?service=wfs&version=1.0.0&request=GetFeature&typeNames=${this.layerData}&outputFormat=application/json&srsname=EPSG:4326&CQL_FILTER=${att}`
        // let url = `/layer?service=wfs&version=1.0.0&request=GetFeature&typeNames=${this.layerData}&outputFormat=application/json&srsname=EPSG:4326&CQL_FILTER=${att}`
        Axios.get(url).then(res =>
        {
          if (res.status === 200 && res.data.features.length > 0)
            this.$emit('setSearchData', res.data)
          else
          {
            this.$message({message: '无属性数据', type: 'error'})
            this.$emit('setSearchData', res.data)
          }
        })
      }
      else
      {
        if (!this.rulesform.attribute)
          this.$message({message: '请选择属性字段', type: 'error', customClass: 'mzindex'})
        else if (!this.rulesform.attvalue)
          this.$message({message: '请输入属性值', type: 'error', customClass: 'mzindex'})
        else if (!this.rulesform.type)
          this.$message({message: '请选择类别', type: 'error', customClass: 'mzindex'})
      }
    },
    // 空间分析确定
    onSubmits()
    {
      console.log(this.rulesform, this.layerData)
      // this.$emit('setSearchDatas', this.form, this.layerData)
    },
    cancel()
    {
      this.rulesform = {}
    },
    // 空间分析-点击工具
    onMeasures(group, index)
    {
      this.$emit('onMeasures', group, this.layerData)
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/plugins/app/assembly/kyxxyzt/SearchBox.vue